"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FacetFiltersForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FacetFiltersForm, _HTMLElement);
  var _super = _createSuper(FacetFiltersForm);
  function FacetFiltersForm() {
    var _this;
    _classCallCheck(this, FacetFiltersForm);
    _this = _super.call(this);
    _this.onActiveFilterClick = _this.onActiveFilterClick.bind(_assertThisInitialized(_this));
    _this.sideBarMode = _this.classList.value.includes('side-bar-filters');
    _this.facetCheckboxes = Array.from(_this.getElementsByClassName('facet-checkbox'));
    if (_this.sideBarMode) {
      _this.openActiveGroups();
    }
    _this.debouncedOnSubmit = debounce(function (event) {
      _this.onSubmitHandler(event);
    }, 500);
    var facetForm = _this.querySelector('form');
    facetForm.addEventListener('input', function (event) {
      if (event.target.closest('price-range')) return;
      _this.debouncedOnSubmit(event);
    });
    facetForm.addEventListener('change', function (event) {
      if (!event.target.closest('price-range')) return;
      _this.onSubmitHandler(event);
    });
    var facetWrapper = _this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    if (_this.sideBarMode) {
      var filterToggleButton = document.getElementById("filter-toggle");
      var sidebarContainer = document.querySelector('.collection-sidebar-mode--container');
      if (filterToggleButton && sidebarContainer) {
        var persistedFiltersOpen = localStorage.getItem('filtersOpen') === 'true';
        sidebarContainer.classList.toggle('filters-open', persistedFiltersOpen);
        filterToggleButton.setAttribute('aria-expanded', String(persistedFiltersOpen));
        filterToggleButton.addEventListener("click", function (event) {
          event.preventDefault();
          sidebarContainer.classList.toggle('filters-open');
          var isExpanded = sidebarContainer.classList.contains('filters-open');
          filterToggleButton.setAttribute('aria-expanded', String(isExpanded));
          localStorage.setItem('filtersOpen', String(isExpanded));
        });
      }
    }

    // Adding styling to checked colour facets and syncing state on page load
    FacetFiltersForm.syncColourFacetStates();
    _this.addEventListener('change', function (event) {
      if (!event.target.classList.contains('facets__checkbox')) return;
      var label = document.querySelector("label.facets__color[for=\"".concat(event.target.id, "\"]"));
      if (label) label.classList.toggle('checked', event.target.checked);
    });
    if (_this.sideBarMode) {
      var allFilterDropdowns = _this.querySelectorAll(':scope .facets__disclosure--sidebar');
      allFilterDropdowns.forEach(function (facet) {
        facet.querySelector('.facets__summary').addEventListener('click', function () {
          facet.querySelector(':scope .facets__display--sidebar').animate(animateMenuOpen(), 200);
        });
      });
    }
    FacetFiltersForm.initMobileFacetsModalTransitions();
    FacetFiltersForm.syncActiveFacetWrappersVisibility();
    return _this;
  }
  _createClass(FacetFiltersForm, [{
    key: "onSubmitHandler",
    value: function onSubmitHandler(event, externalSort) {
      event.preventDefault();
      if (this.sideBarMode && event.target.closest('price-range')) {
        var form = event.target.closest('form');
        if (!form) return;
        // Build params from current form values to avoid duplicate price params in the URL
        var currentParams = new URLSearchParams(new FormData(form));
        var previousParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
        currentParams.forEach(function (value, key) {
          if (key.indexOf('filter.') === 0 && value === '') currentParams["delete"](key);
        });
        if (!currentParams.has('sort_by') && previousParams.has('sort_by')) {
          currentParams.set('sort_by', previousParams.get('sort_by'));
        }
        FacetFiltersForm.renderPage(currentParams.toString(), event);
        return;
      }
      var formData = new FormData(event.target.closest('form'));
      var searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }
  }, {
    key: "onActiveFilterClick",
    value: function onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      var url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  }, {
    key: "openActiveGroups",
    value: function openActiveGroups() {
      this.facetCheckboxes.forEach(function (checkbox) {
        if (checkbox.firstElementChild.hasAttribute('checked')) {
          checkbox.closest('details').setAttribute('open', 'open');
        }
      });
    }
  }], [{
    key: "syncColourFacetStates",
    value: function syncColourFacetStates() {
      document.querySelectorAll('label.facets__color').forEach(function (label) {
        var checkbox = document.getElementById(label.htmlFor);
        if (checkbox) label.classList.toggle('checked', checkbox.checked);
      });
    }
  }, {
    key: "initMobileFacetsModalTransitions",
    value: function initMobileFacetsModalTransitions() {
      var detailsElements = document.querySelectorAll('.mobile-facets__disclosure');
      detailsElements.forEach(function (detailsElement) {
        if (detailsElement.dataset.modalTransitionsBound === 'true') return;
        var overlay = detailsElement.querySelector('.mobile-facets');
        var panel = detailsElement.querySelector('.mobile-facets__inner');
        var summary = detailsElement.querySelector('summary');
        if (!overlay || !panel || !summary) return;
        var overlayAnimation = null;
        var panelAnimation = null;
        var previousIsOpen = detailsElement.hasAttribute('open');
        var previousIsMenuOpening = detailsElement.classList.contains('menu-opening');
        var setClosedState = function setClosedState() {
          overlay.style.pointerEvents = 'none';
          overlay.style.opacity = '0';
        };
        var playOpenAnimation = function playOpenAnimation() {
          overlay.style.pointerEvents = 'auto';
          if (overlayAnimation) overlayAnimation.cancel();
          if (panelAnimation) panelAnimation.cancel();
          overlayAnimation = overlay.animate([{
            opacity: 0
          }, {
            opacity: 1
          }], {
            duration: 300,
            fill: 'forwards'
          });
        };
        var playCloseAnimation = function playCloseAnimation() {
          overlay.style.pointerEvents = 'none';
          if (overlayAnimation) overlayAnimation.cancel();
          if (panelAnimation) panelAnimation.cancel();
          overlayAnimation = overlay.animate([{
            opacity: 1
          }, {
            opacity: 0
          }], {
            duration: 300,
            fill: 'forwards'
          });
          panelAnimation = panel.animate([{
            opacity: 1
          }, {
            opacity: 0
          }], {
            duration: 250,
            fill: 'forwards'
          });
        };
        overlay.addEventListener('click', function (event) {
          if (event.target.closest('.mobile-facets__inner')) return;
          if (!detailsElement.hasAttribute('open')) return;
          summary.click();
        });
        var syncState = function syncState() {
          var isOpen = detailsElement.hasAttribute('open');
          var isMenuOpening = detailsElement.classList.contains('menu-opening');
          if (!previousIsMenuOpening && isMenuOpening && isOpen) {
            playOpenAnimation();
          }
          if (previousIsMenuOpening && !isMenuOpening) {
            playCloseAnimation();
          }
          if (previousIsOpen && !isOpen && !isMenuOpening) {
            setClosedState();
          }
          previousIsOpen = isOpen;
          previousIsMenuOpening = isMenuOpening;
        };
        var observer = new MutationObserver(syncState);
        observer.observe(detailsElement, {
          attributes: true,
          attributeFilter: ['class', 'open']
        });
        setClosedState();
        if (previousIsOpen && previousIsMenuOpening) {
          overlay.style.pointerEvents = 'auto';
          overlay.style.opacity = '1';
        }
        detailsElement.dataset.modalTransitionsBound = 'true';
      });
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var onHistoryChange = function onHistoryChange(event) {
        var searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);
      FacetFiltersForm.initMobileFacetsModalTransitions();
      var mobileSortRadioWrappers = document.querySelectorAll('.sort-radio__field-group');
      mobileSortRadioWrappers.forEach(function (sortRadio) {
        sortRadio.addEventListener('click', function (event) {
          for (var i = 0; i < mobileSortRadioWrappers.length; i++) {
            mobileSortRadioWrappers[i].querySelector('input[type="radio"]').removeAttribute('checked');
          }
          event.currentTarget.querySelector('input[type="radio"]').click();
          event.currentTarget.querySelector('input[type="radio"]').setAttribute('checked', 'checked');
        });
      });
    }
  }, {
    key: "toggleActiveFacets",
    value: function toggleActiveFacets() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      document.querySelectorAll('.js-facet-remove').forEach(function (element) {
        element.classList.toggle('disabled', disable);
      });
    }
  }, {
    key: "renderPage",
    value: function renderPage(searchParams, event) {
      var updateURLHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      FacetFiltersForm.searchParamsPrev = searchParams;
      var sections = FacetFiltersForm.getSections();
      var countContainer = document.getElementById('ProductCount');
      var countContainerDesktop = document.getElementById('ProductCountDesktop');
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }
      sections.forEach(function (section) {
        var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
        var filterDataUrl = function filterDataUrl(element) {
          return element.url === url;
        };
        FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  }, {
    key: "renderSectionFromFetch",
    value: function renderSectionFromFetch(url, event) {
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        FacetFiltersForm.filterData = [].concat(_toConsumableArray(FacetFiltersForm.filterData), [{
          html: html,
          url: url
        }]);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
    }
  }, {
    key: "renderSectionFromCache",
    value: function renderSectionFromCache(filterDataUrl, event) {
      var html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    }
  }, {
    key: "renderProductGridContainer",
    value: function renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    }
  }, {
    key: "renderProductCount",
    value: function renderProductCount(html) {
      var count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      var container = document.querySelectorAll('#ProductCount');
      var containerDesktop = document.querySelectorAll('#ProductCountDesktop');
      container.forEach(function (countString) {
        countString.innerHTML = count;
        countString.classList.remove('loading');
      });
      var iscroll = document.querySelector('infinite-scroll');
      iscroll ? iscroll.setAttribute('data-filtered-collection-count', count) : null;
      if (containerDesktop) {
        containerDesktop.forEach(function (conDesk) {
          conDesk.innerHTML = count;
          conDesk.classList.remove('loading');
        });
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters(html, event) {
      var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      var facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
      var matchesIndex = function matchesIndex(element) {
        var jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      };
      var facetsToRender = Array.from(facetDetailsElements).filter(function (element) {
        return !matchesIndex(element);
      });
      var countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
      facetsToRender.forEach(function (element) {
        document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]")).innerHTML = element.innerHTML;
      });
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
      FacetFiltersForm.setListeners();
      FacetFiltersForm.syncColourFacetStates();
    }
  }, {
    key: "renderActiveFacets",
    value: function renderActiveFacets(html) {
      var activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
      activeFacetElementSelectors.forEach(function (selector) {
        var sourceActiveFacetElements = Array.from(html.querySelectorAll(selector));
        if (!sourceActiveFacetElements.length) return;
        var targetActiveFacetElements = Array.from(document.querySelectorAll(selector));
        targetActiveFacetElements.forEach(function (targetElement, index) {
          var sourceElement = sourceActiveFacetElements[index] || sourceActiveFacetElements[0];
          if (sourceElement) targetElement.innerHTML = sourceElement.innerHTML;
        });
      });
      FacetFiltersForm.toggleActiveFacets(false);
      FacetFiltersForm.syncActiveFacetWrappersVisibility();
    }
  }, {
    key: "syncActiveFacetWrappersVisibility",
    value: function syncActiveFacetWrappersVisibility() {
      document.querySelectorAll('.active-facets').forEach(function (activeFacetContainer) {
        var hasActiveFacets = Boolean(activeFacetContainer.querySelector('facet-remove:not(.active-facets__button-wrapper) .active-facets__button'));
        activeFacetContainer.querySelectorAll('.active-facets__button-wrapper').forEach(function (clearAllWrapper) {
          return clearAllWrapper.toggleAttribute('hidden', !hasActiveFacets);
        });
        var parentWrapper = activeFacetContainer.closest('.active-facets__wrapper');
        if (parentWrapper) {
          parentWrapper.toggleAttribute('hidden', !hasActiveFacets);
        }
      });
    }
  }, {
    key: "renderAdditionalElements",
    value: function renderAdditionalElements(html) {
      var mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
      mobileElementSelectors.forEach(function (selector) {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
      FacetFiltersForm.initMobileFacetsModalTransitions();
      // Commented out so 'sort by' inner text is not updated. This is because it was updating on filter select when no sort by was selected. 
      // let selectedSortby = document.querySelector('.sort-radio__fieldset input[checked="checked"]') ? document.querySelector('.sort-radio__fieldset input[checked="checked"]').parentElement : null;
      // let sortRadio = document.querySelector('.sort-radio__container summary');
      // if(selectedSortby != null){
      // 	sortRadio.innerText = selectedSortby.querySelector('label').innerHTML;
      // } else {
      // 	sortRadio.innerText = sortRadio.dataset.langString;
      // }
    }
  }, {
    key: "renderCounts",
    value: function renderCounts(source, target) {
      var targetElement = target.querySelector('.facets__selected');
      var sourceElement = source.querySelector('.facets__selected');
      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }
    }
  }, {
    key: "updateURLHash",
    value: function updateURLHash(searchParams) {
      history.pushState({
        searchParams: searchParams
      }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
    }
  }, {
    key: "getSections",
    value: function getSections() {
      return [{
        section: document.getElementById('product-grid').dataset.id
      }];
    }
  }]);
  return FacetFiltersForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
var PriceRange = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PriceRange, _HTMLElement2);
  var _super2 = _createSuper(PriceRange);
  function PriceRange() {
    var _this2;
    _classCallCheck(this, PriceRange);
    _this2 = _super2.call(this);
    _this2.querySelectorAll('input').forEach(function (element) {
      return element.addEventListener('change', _this2.onRangeChange.bind(_assertThisInitialized(_this2)));
    });
    _this2.setMinAndMaxValues();
    return _this2;
  }
  _createClass(PriceRange, [{
    key: "onRangeChange",
    value: function onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  }, {
    key: "setMinAndMaxValues",
    value: function setMinAndMaxValues() {
      var inputs = this.querySelectorAll('input');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }, {
    key: "adjustToValidValues",
    value: function adjustToValidValues(input) {
      var value = Number(input.value);
      var min = Number(input.getAttribute('min'));
      var max = Number(input.getAttribute('max'));
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }]);
  return PriceRange;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('price-range', PriceRange);
var FacetRemove = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(FacetRemove, _HTMLElement3);
  var _super3 = _createSuper(FacetRemove);
  function FacetRemove() {
    _classCallCheck(this, FacetRemove);
    return _super3.apply(this, arguments);
  }
  _createClass(FacetRemove, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      if (this._listenerAttached) return;
      var a = this.querySelector('a');
      if (!a) return;
      a.addEventListener('click', function (event) {
        event.preventDefault();
        var form = _this3.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
      this._listenerAttached = true;
    }
  }]);
  return FacetRemove;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('facet-remove', FacetRemove);